module.exports = __webpack_public_path__ + "static/media/List report.8eff3f61.svg";